import styled from '@emotion/styled';
import { css } from 'emotion';

import { getThemeColor } from '@ezugi/ui/theme';

export const Container = styled.div`
  background-color: ${getThemeColor('primary')};
  padding: 4px;

  > div {
    padding: 4px 15px;
  }
`;

export const mobileClassName = css`
  @media all and (orientation: portrait) {
    grid-template-columns: repeat(10, minmax(30px, 1fr));
  }

  @media all and (orientation: landscape) {
    grid-template-columns: repeat(20, minmax(24px, 1fr));
  }
`;

export const switcherClassName = css`
  padding: 4px;
  margin-bottom: 10px;

  h3 {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: pre-wrap;
    max-width: calc(100% - 32px);
  }

  li {
    justify-content: flex-start;
    height: 48px;
    padding: 0;

    & > div {
      margin: 0 10px;
    }

    &:after {
      width: 100%;
      content: '';
      position: absolute;
      height: 1px;
      bottom: 0;
      background-color: rgba(255, 255, 255, 0.2);
    }
  }

  li[data-active=true] {
    &:after {
      background-color: #FFD43A;
    }
  }
`;

export const dropdownContainerClassName = css`
  position: absolute;
  z-index: 20;
  height: auto;
  color: ${getThemeColor('primaryContrast')};
  top: 0;
  right: 0;
  padding: 0;
  margin: 0;
`;

export const Delimiter = styled.div`
  display: flex;
  width: 100%;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  margin: 15px 0 20px 0;
  padding: 0;
`;
